.e2{gap:0.375rem;}